// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS definition */
.WordBreak-module__Container__maxkr {
    color: inherit;
    font-weight: inherit;
    font-size: inherit;
    line-height: inherit;
    overflow-wrap: break-word;
}
/* stylelint-enable property-disallowed-list */
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `WordBreak-module__Container__maxkr`
};
export default ___CSS_LOADER_EXPORT___;
